function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { rgbToHsl, rgbToHex } from "./util.js";
export class Swatch {
  constructor(rgb, population) {
    _defineProperty(this, "rgb", void 0);

    _defineProperty(this, "hsl", void 0);

    _defineProperty(this, "yiq", void 0);

    _defineProperty(this, "hex", void 0);

    _defineProperty(this, "population", void 0);

    this.rgb = rgb;
    this.hex = rgbToHex(...rgb);
    this.hsl = rgbToHsl(...rgb);
    this.yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
    this.population = population;
  }

  get r() {
    return this.rgb[0];
  }

  get g() {
    return this.rgb[1];
  }

  get b() {
    return this.rgb[2];
  }

  toJSON() {
    return {
      rgb: this.rgb,
      population: this.population
    };
  }

}

_defineProperty(Swatch, "applyFilter", (colors, f) => typeof f === `function` ? colors.filter(({
  r,
  g,
  b
}) => f(r, g, b, 255)) : colors);